import { Pipe, PipeTransform } from '@angular/core';


@Pipe({name: 'replaceLineBreaks'})
export class ReplaceLineBreaks implements PipeTransform {
transform(value: string): string {
      if (value === null || value === undefined) {
         return '';
      }
      return String(value).replace(/\n/g, '<br/><br/>');
   }
}
 
